import { render, staticRenderFns } from "./promotionStrategy.vue?vue&type=template&id=384d6869&scoped=true"
import script from "./promotionStrategy.vue?vue&type=script&lang=js"
export * from "./promotionStrategy.vue?vue&type=script&lang=js"
import style0 from "./promotionStrategy.vue?vue&type=style&index=0&id=384d6869&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384d6869",
  null
  
)

export default component.exports